import styled, { css } from 'styled-components'

interface ContentProps {
  fluid?: boolean
  basic?: boolean
  noPadding?: boolean
  noMinHeight?: boolean
  allowOverflow?: boolean
}

interface VariableWidthContainerProps {
  basic?: boolean
  noPadding?: boolean
  noMinHeight?: boolean
  allowOverflow?: boolean
  expanded?: boolean
}

export const Content = styled.div<ContentProps>`
  ${({ theme, fluid, basic, noPadding, noMinHeight, allowOverflow }) => css`
    position: relative;
    background: ${basic ? 'none' : '#fff'};
    border: ${basic ? 'none' : '1px solid #dbe2ef'};
    padding: ${noPadding ? '0' : '1em'};
    border-radius: 4px;
    overflow: ${allowOverflow ? 'visible' : 'hidden'};

    ${!basic &&
    css`
      min-height: ${noMinHeight ? '140px' : 'calc(100vh - 140px)'};
    `}

    ${!fluid &&
    css`
      width: calc(100% - 190px);
      left: 225px;
    `}

      ${theme.mediaQueries.mobile} {
      width: calc(100% + 2em);
      margin: 0 -1em;
      left: 0;
      border: 0;
      border-radius: 0;
    }
  `}
`

export const VariableWidthContainer = styled.div<VariableWidthContainerProps>`
  ${({ theme, basic, noPadding, noMinHeight, allowOverflow, expanded }) => css`
    position: relative;
    background: ${basic ? 'none' : '#fff'};
    border: ${basic ? 'none' : '1px solid #dbe2ef'};
    padding: ${noPadding ? '0' : '1em'};
    border-radius: 4px;
    overflow: ${allowOverflow ? 'visible' : 'hidden'};
    margin-right: 25px;
    margin-left: auto;
    transition: width 300ms ease-in;
    width: ${!expanded ? 'calc(100% - 50px)' : 'calc(100% - 300px)'};

    ${!basic &&
    css`
      min-height: ${noMinHeight ? '140px' : 'calc(100vh - 140px)'};
    `}

    ${theme.mediaQueries.mobile} {
      width: calc(100% + 2em);
      margin: 0 -1em;
      left: 0;
      border: 0;
      border-radius: 0;
    }
  `}
`
